import React from "react"
import PropTypes from "prop-types"
import { Calendar } from "primereact/calendar"
import { MultiSelect } from "primereact/multiselect"
import { InputText } from "primereact/inputtext"
import { Dropdown } from "primereact/dropdown"
import { Button } from "primereact/button"
import styles from "../../../../styles/ListPageView.module.css"

const Filters = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onFilterData,
  onClearSelection,
  locationFilter,
  dynamicFilters,
  onLocationFilterChange,
  staffFilter,
  onStaffFilterChange,
  programFilter,
  onProgramFilterChange,
  locationOptions,
  staffOptions,
  programOptions,
  setDynamicFilters,
  disableFilter,
}) => {
  const renderDynamicFilter = (filter, index) => {
    switch (filter.type) {
      case "keyword":
        return (
          <div key={index} className={styles["filter-field"]}>
            <label>{filter.label}:</label>
            <InputText
              value={filter.value || ""}
              onChange={(e) => {
                filter.onChange(e)
                setDynamicFilters((prevFilters) =>
                  prevFilters.map((f) =>
                    f.id === filter.id ? { ...f, value: e.target.value } : f
                  )
                )
              }}
              placeholder={filter.placeholder}
            />
          </div>
        )

      case "select":
        return (
          <div key={index} className={styles["filter-field"]}>
            <label>{filter.label}:</label>
            <Dropdown
              value={filter.value}
              options={filter.options}
              onChange={(e) => {
                filter.onChange(e)

                setDynamicFilters((prevFilters) =>
                  prevFilters.map((f) =>
                    f.id === filter.id ? { ...f, value: e.value } : f
                  )
                )
              }}
              placeholder={filter.placeholder}
            />
          </div>
        )

      default:
        return null
    }
  }

  return (
    <div className={styles["filter-container"]}>
      <div className={styles["filter-fields"]}>
        <div className={styles["filter-field"]}>
          <label htmlFor="startDate">Start Date:</label>
          <Calendar
            id="startDate"
            value={startDate}
            onChange={(e) => onStartDateChange(e.value)}
            dateFormat="mm/dd/yy"
            showIcon
          />
        </div>
        <div className={styles["filter-field"]}>
          <label htmlFor="endDate">End Date:</label>
          <Calendar
            id="endDate"
            value={endDate}
            onChange={(e) => onEndDateChange(e.value)}
            dateFormat="mm/dd/yy"
            showIcon
          />
        </div>
        <div className={styles["filter-field"]}>
          <label htmlFor="staffFilter">Staff:</label>
          <MultiSelect
            id="staffFilter"
            value={staffFilter}
            options={staffOptions}
            onChange={(e) => onStaffFilterChange(e.value)}
            placeholder="Select Staff"
            display="chip"
          />
        </div>
        {!disableFilter && (
          <div className={styles["filter-field"]}>
            <label htmlFor="locationFilter">Location:</label>
            <MultiSelect
              id="locationFilter"
              value={locationFilter}
              options={locationOptions}
              onChange={(e) => onLocationFilterChange(e.value)}
              placeholder="Select Locations"
              display="chip"
            />
          </div>
        )}
        <div className={styles["filter-field"]}>
          <label htmlFor="programFilter">Program:</label>
          <MultiSelect
            id="programFilter"
            value={programFilter}
            options={programOptions}
            onChange={(e) => onProgramFilterChange(e.value)}
            placeholder="Select Programs"
            display="chip"
          />
        </div>

        {dynamicFilters?.map((filter, index) =>
          renderDynamicFilter(filter, index)
        )}
      </div>

      <div className={styles["filter-actions"]}>
        <Button
          label="Filter results"
          onClick={onFilterData}
          className={styles["apply-button"]}
        />
        <Button
          label="Clear Selection"
          onClick={onClearSelection}
          className={styles["clear-button"]}
        />
      </div>
    </div>
  )
}

Filters.propTypes = {
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  onStartDateChange: PropTypes.func.isRequired,
  onEndDateChange: PropTypes.func.isRequired,
  onFilterData: PropTypes.func.isRequired,
  onClearSelection: PropTypes.func.isRequired,
  locationFilter: PropTypes.arrayOf(PropTypes.string),
  onLocationFilterChange: PropTypes.func.isRequired,
  staffFilter: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    })
  ),
  onStaffFilterChange: PropTypes.func.isRequired,
  programFilter: PropTypes.arrayOf(PropTypes.string),
  onProgramFilterChange: PropTypes.func.isRequired,
  locationOptions: PropTypes.arrayOf(PropTypes.string),
  staffOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    })
  ),
  programOptions: PropTypes.arrayOf(PropTypes.string),
  dynamicFilters: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.any,
      options: PropTypes.array,
      placeholder: PropTypes.string,
      onChange: PropTypes.func.isRequired,
      type: PropTypes.string.isRequired,
    })
  ),
  setDynamicFilters: PropTypes.func.isRequired,
}

export default Filters
